<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "临时用户消费明细",
      items: [
        { text: "用户管理", href: "/user/list" },
        { text: "临时用户", href: "/user/temporary" },
        { text: "消费明细", active: true },
      ],
      userinfo: [],
      loading: false,
      hex: "",
      username: "",
      list: [],
      pageSize: 20,
      currentPage: 1,
    };
  },
  mounted() {
    this.userinfo = JSON.parse(localStorage.getItem("user"));
    this.hex = this.$route.query.hex || "";
    this.username = this.$route.query.username || "";
    this.getOrderDetail();
  },
  methods: {
    getOrderDetail() {
      if (!this.hex) {
        this.$message.error("缺少用户卡号参数");
        return;
      }
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "gettempuserorderdetail",
            hex: this.hex,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status === 200) {
            this.list = response.data.data || [];
          } else {
            this.$message.error("获取消费明细失败");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("获取消费明细失败");
        });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    },
  },
  computed: {
    showTable() {
      return this.list.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
  },
  filters: {
    formatTimer(value) {
      const sec = parseInt(value, 10);
      if (!sec || sec <= 0) return "-";
      const date = new Date(sec * 1000);
      const y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return `${y}-${MM}-${d} ${h}:${m}:${s}`;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading">
            <div class="mb-3">
              <el-tag type="info" size="mini">用户：{{ username || "-" }}</el-tag>
              <el-tag type="success" size="mini" class="ml-2">卡号：{{ hex || "-" }}</el-tag>
            </div>
            <el-table :data="showTable" stripe border size="mini" style="width: 100%">
              <el-table-column prop="id" label="序列号" width="100"></el-table-column>
              <el-table-column prop="hex" label="卡号" width="110" show-overflow-tooltip></el-table-column>
              <el-table-column prop="ED_id" label="设备ID" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column prop="ED_name" label="设备名称" min-width="130" show-overflow-tooltip></el-table-column>
              <el-table-column prop="hd_no" label="货道" width="80"></el-table-column>
              <el-table-column prop="goodstotal" label="商品数量" width="100"></el-table-column>
              <el-table-column prop="total" label="支付金额" width="100"></el-table-column>
              <el-table-column prop="paytime" label="支付时间" min-width="170">
                <template slot-scope="scope">
                  {{ scope.row.paytime | formatTimer }}
                </template>
              </el-table-column>
            </el-table>
            <div class="resource-page">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="prev, pager, next, sizes, jumper, total"
                :total="list.length">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.resource-page {
  margin-top: 20px;
  text-align: center;
}
.ml-2 {
  margin-left: 8px;
}
</style>
